import { z } from 'zod';
import { PERMISSIONS } from '../constants/permissions.js';
import { email, name, objectId, optional, phone, pin, reason } from './common.js';

export const createUserSchema = z.strictObject({
  name,
  email: optional(email),
  phone: optional(phone),
  roleId: objectId,
  outletIds: z.array(objectId).max(200).default([]),
  pin: optional(pin),
  sendInvite: z.boolean().default(true),
});

export const updateUserSchema = z.strictObject({
  name: name.optional(),
  email: optional(email),
  phone: optional(phone),
  roleId: objectId.optional(),
  outletIds: z.array(objectId).max(200).optional(),
  status: z.enum(['active', 'disabled']).optional(),
});

export const setPinSchema = z.strictObject({ pin });

export const roleSchema = z.strictObject({
  name: z.string().trim().min(2).max(40),
  permissions: z.array(z.enum(PERMISSIONS)).max(PERMISSIONS.length),
  limits: z.strictObject({
    maxDiscountPct: z.coerce.number().int().min(0).max(100),
    maxDiscountPaise: optional(z.coerce.number().int().min(0)),
  }),
});

export const revokeSchema = z.strictObject({ reason });
